function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M36.214 28.786a7 7 0 11-12.428 0l-5.02-5.02a6.925 6.925 0 01-5.612-.921L7 29l-3-3 6.477-6.477a7 7 0 1111.947 1.9l4.363 4.363a6.965 6.965 0 016.428 0L42 17l3 3z",
  fillRule: "evenodd",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 14a3 3 0 11-3 3 3 3 0 013-3zm13 15a3 3 0 11-3 3 3 3 0 013-3z",
  fill: "#0f0f0f",
  fillRule: "evenodd"
});

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 48 48"
  }, props), _ref, _ref2);
}

export default SvgLogo;